module.exports = __webpack_public_path__ + "img/b1.dc00a10.webp";